"use strict";

const OutfallFunctions = function () {
  var isOutfallDataView = function (dataView) {
    const outfallDataViews = ["outfalls", "muni-outfalls"];
    return outfallDataViews.includes(dataView);
  };

  var invalidateCurrentOutfallLayerWithoutLoadingScreen = function () {
    return invalidateOutfallLayerDataByDataView(undefined, false);
  };

  var invalidateOutfallLayerDataByDataView = function (
    dataView = Tree.get("dataView"),
    loadingScreen = true,
  ) {
    if (dataView === "dry-weather") {
      MonitoringLocationGeoServerLayer.invalidateLayerData();
    } else if (isOutfallDataView(dataView)) {
      LayerFunctions.getCurrentLayerModule(dataView).invalidateLayerData(loadingScreen);
    } else {
      LayerFunctions.getLayerModule("outfallsSimple").invalidateLayerData();
    }

    if (dataView === "wq-monitoring") {
      WqMonitoringLocationGeoServerLayer.invalidateLayerData();
    }
  };

  return {
    isOutfallDataView,
    invalidateOutfallLayerDataByDataView,
    invalidateCurrentOutfallLayerWithoutLoadingScreen,
  };
};

module.exports = OutfallFunctions();

const LayerFunctions = require("../layerFunctions");
const MonitoringLocationGeoServerLayer = require("../illicitDischarge/monitoringLocationGeoServerLayer");
const Tree = require("../tree");
const WqMonitoringLocationGeoServerLayer = require("../wq/wqMonitoringLocationGeoServerLayer");
